import { Box } from 'components/Box/Box';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { LegacyPrimaryButton } from 'components/LegacyButton/LegacyPrimaryButton';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiLogosBlockData } from 'modules/cms/api/types/blocks/CmsApiLogosBlock';
import { trackAnchorClicked } from 'utils/analytics/track/trackAnchorClicked';

import {
  LogoImageContainer,
  LogoImageGroupContainer,
  LogosButtonContainer,
} from './CmsLogosBlock.styled';

type Props = {
  data: CmsApiLogosBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsLogosBlock({ data, blockIndex, pageUpdated }: Props) {
  const { headline, sections, buttonText, buttonUrl } = data;

  return (
    <Box data-qa-id={`logos-${blockIndex}`}>
      {headline && (
        <RichTextHeadline textAlignCenter>{headline}</RichTextHeadline>
      )}
      {sections.map((section) => (
        <LogoImageGroupContainer>
          <LogoImageContainer>
            <FilestackImage
              alt={section.imageOne.altText}
              data={section.imageOne}
              data-qa-id={`image-${section.imageOne.altText}`}
              height={94}
            />
          </LogoImageContainer>
          <LogoImageContainer>
            <FilestackImage
              alt={section.imageTwo.altText}
              data={section.imageTwo}
              data-qa-id={`image-${section.imageTwo.altText}`}
              height={94}
            />
          </LogoImageContainer>
          <LogoImageContainer>
            <FilestackImage
              alt={section.imageThree.altText}
              data={section.imageThree}
              data-qa-id={`image-${section.imageThree.altText}`}
              height={94}
            />
          </LogoImageContainer>
        </LogoImageGroupContainer>
      ))}

      {buttonText && buttonUrl && (
        <LogosButtonContainer>
          <LegacyPrimaryButton
            component={StyledNativeLinkWithRef}
            href={buttonUrl}
            mt={24}
            onClick={(event) =>
              trackAnchorClicked(event, 'CMS Block', {
                block_position: blockIndex,
                block_type: 'Logos',
                cta_type: 'Button',
                page_updated: pageUpdated,
              })
            }
          >
            {buttonText}
          </LegacyPrimaryButton>
        </LogosButtonContainer>
      )}
    </Box>
  );
}
